import { IValidator } from "./IValidator";
import { addPatientInitialConfiguration, patientInvalidFieldMessage } from '../patient_constants';

export class MaxLengthValidator implements IValidator {
    private errorMessages = new Array<string>();

    isValid(data: any): boolean {
        const hasValidLength = data.length <= addPatientInitialConfiguration.nameMaxLength;

        this.errorMessages = [];
        if (!hasValidLength) {
            this.errorMessages.push(patientInvalidFieldMessage.invalidMaxLengthField);
        }
        return hasValidLength;
    }

    getErrorMessages(): string[] {
        return this.errorMessages;
    }
}
